























































import Vue from 'vue';
import Component from "vue-class-component";
import {Client} from "../model/interface/client.interface";
import {ClientService} from "../services/client.service";
import store from "../store/store";

@Component
export default class Account extends Vue {
  private user: Client;
  private roles: string[] = [];

  get isAdmin() {
    if (this.user.admin) {
      return "Admin";
    } else {
      return "";
    }
  }


  private async beforeMount() {
    this.user = this.$store.getters.user;
    this.roles = await ClientService.getRoles();
  }

  public async routeToLogout() {
    this.$router.push('/logout');
  }
}
